import { AuthState } from '../../../../redux/features/Auth'
import { parseError } from '../../../../redux/features/Auth/actions'

export const setLoginError = (message: string): AuthState['error'] =>
  parseError(message)
